// extracted by mini-css-extract-plugin
export default {"section":"responsiveStyles_section__F6Y2t","inner":"responsiveStyles_inner__5L9i9","grid":"responsiveStyles_grid__9Z7S4"};